import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {ClientConfigPreview, ClientPreparationResult, IClientProductionConfigSyncResult} from '../../models/client-production-config-sync.model';

@Injectable({
    providedIn: 'root'
})
export class ClientProductionConfigSyncService {
    private readonly http = inject(HttpClient);

    private getEndpoint(clientId: string): string {
        return `${environment.aiBaseServerUrl}${encodeURIComponent(clientId)}/clients/config-sync/production`;
    }

    preview(clientId: string, configurationOnly = false): Observable<ClientConfigPreview> {
        return this.http.post<ClientConfigPreview>(`${this.getEndpoint(clientId)}/preview${configurationOnly ? '?configurationOnly=true' : ''}`, {});
    }

    prepareLocal(clientId: string): Observable<ClientPreparationResult> {
        return this.http.post<ClientPreparationResult>(
            `${environment.aiBaseServerUrl}${encodeURIComponent(clientId)}/clients/config-sync/prepare-local`, {});
    }

    syncFromProduction(clientId: string, revision: string, prepareLocal = false, configurationOnly = false): Observable<IClientProductionConfigSyncResult> {
        return this.http.post<IClientProductionConfigSyncResult>(this.getEndpoint(clientId),
            configurationOnly ? {revision, configurationOnly} : prepareLocal ? {revision, prepareLocal} : {revision});
    }
}
